import { useQuery, useQueryClient } from '@tanstack/react-query';
import { localStateKeys } from '../utils/reportviewutils';
import { getWorksheetReportTemplateConfig } from '../services/config/function';
import { worksheetReportTemplateConfigKeys } from '../services/config/key';
import { getFindings } from '../services/report/function';
import { findingKeys } from '../services/report/key';
import '../styles/main.css';

function Finding() {
  const queryClient = useQueryClient();
  const numBlocks = queryClient.getQueryData<number>(localStateKeys.maxBlocks);

  const { status : status, data : data, error: error } = useQuery({
    queryKey: worksheetReportTemplateConfigKeys.all,
    queryFn: getWorksheetReportTemplateConfig,
    staleTime: Infinity,
    meta: { numBlocks : numBlocks, numParams : 10 },
  })

  // event handler 
  const handleTestButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.currentTarget;
    queryClient.invalidateQueries({queryKey: findingKeys.all});
    event.preventDefault();
  }

  // if (isPending) 
  if (status === 'pending') {
    return <span>Loading...</span>
  }

  // if (isError) 
  if (status === 'error') {
    return <span>Error: {error.message}</span>
  }

  const { status : statusFinding, data : dataFinding, error: errorFinding } = useQuery({
    queryKey: findingKeys.all,
    queryFn: getFindings,
    staleTime: Infinity,
    meta: { numBlocks : 100, numParams : 10 },
  })

  // if (isPending) 
  if (statusFinding === 'pending') {
    return <span>Loading...</span>
  }

  // if (isError) 
  if (statusFinding === 'error') {
    return <span>Error: {errorFinding.message}</span>
  }

  return (
    <>
      { 
        (() => {
          data;
          dataFinding;
          console.log('edit and preview component is now rendering...');
          return null;
        })() && undefined
      }
      <section className="button-section">
        <button 
         onClick={handleTestButtonClick}>
          Test[Full value change]
        </button>
      </section>
      <section>
        <h1>TO BE IMPLEMENTED</h1>
        {/*dataFinding.map((item) => (
          <p></p> || data || item 
        ))*/undefined}
        <p className="read-the-docs">
          Footer part.
        </p>
      </section>
    </>
  )
}

export default Finding
